import { axiosInstance } from './axiosInstance';

const PAID_STATUS_CODE = 3;

export interface IPixPaymentStatus {
  paid: boolean;
}

export async function fetchPixPaymentStatus(
  transactionId: string
): Promise<IPixPaymentStatus> {
  const { data } = await axiosInstance({
    method: 'GET',
    url: `${process.env.NEXT_PUBLIC_API_PRO}/purchase/status`,
    params: { id: transactionId },
  });

  return { paid: data?.status === PAID_STATUS_CODE };
}
